<shakespeare-spinning-loader *ngIf="loading"></shakespeare-spinning-loader>

<div class="container" *ngIf="!loading">
	<shakespeare-spinning-loader></shakespeare-spinning-loader>
</div>
